import MainStore from "../store/MainStore";

class UserAnnexesService {

    getdefaultAnnexes(){

        return   {
            "a5_ta": null,
            "a5_td": 2.5,
            "a1_txt": "Les règles d’urbanisme, la liste des taxes et participations d’urbanisme ainsi que les limitations administratives au droit de propriété applicables au terrain sont mentionnées aux articles 2 et suivants du présent certificat. \n\n" +
                "Conformément au quatrième alinéa de l’article L. 410-1 du code de l’urbanisme, si une demande de permis de construire, d’aménager ou de démolir ou si une déclaration préalable est déposée dans le délai de dix-huit mois à compter de la date du présent certificat d'urbanisme, les dispositions d'urbanisme, le régime des taxes et participations d'urbanisme ainsi que les limitations administratives au droit de propriété tels qu'ils existaient à cette date ne peuvent être remis en cause à l'exception des dispositions qui ont pour objet la préservation de la sécurité ou de la salubrité publique.",
            "a2_txt": "Le terrain est situé dans une commune dotée d’un plan local d’urbanisme susvisé. \n\n" +
                "Les articles suivants du code de l'urbanisme sont notamment applicables :  \n" +
                "- art. L 111-1-4, art. R 111-2, R 111-4, R 111-15 et R 111-21.",
            "a5_rap": 0.4,
            "a6_txt1": "- Participation pour équipements publics exceptionnels (articles L. 332-6-1-2° c) et L. 332-8 du code de l’urbanisme)",
            "a6_txt2": "- Participation pour voiries et réseaux (articles L. 332-6-1-2° d), L. 332-11-1 et L. 332-11-2 du code de l’urbanisme) ",
            "intro_txt": "Le Maire,\n" +
                "\n" +
                "Vu la demande d’un certificat d’urbanisme indiquant, en application des articles L 410-1, R 410-1 et suivants du code de l’urbanisme, les dispositions d’urbanisme, les limitations administratives au droit de propriété et la liste des taxes et participations applicables.",
            "delivrance_txt":  "Délivré par le Maire au nom de la commune ",
        }
    }

}

export default UserAnnexesService
